import { useTranslation } from 'react-i18next';

import { ELanguage } from '#core/const/locales';

export const useLanguage = () => {
    const { i18n } = useTranslation();

    const isZH = i18n.language === ELanguage.ZH;
    const isRU = i18n.language === ELanguage.RU;
    const isEN = i18n.language === ELanguage.EN;

    return { language: i18n.language, isZH, isRU, isEN };
};
